var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconRightRoundedArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 25.502c-.528.527-1.132.645-1.812.353-.681-.291-1.022-.812-1.022-1.562V15.71c0-.75.34-1.27 1.022-1.562.68-.292 1.284-.174 1.811.354l4.334 4.333c.166.167.291.347.375.542.083.194.125.402.125.625 0 .222-.042.43-.125.625a1.732 1.732 0 01-.375.541l-4.334 4.334z",
    fill: "#606060"
  })));
}

export default SvgIconRightRoundedArrow;